import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { guideCards } from '@/mocks/admissionData';

export default function GuideCards() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('admission.guide.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('admission.guide.title')}
          </h2>
          {String(t('admission.guide.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          {String(t('admission.guide.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guideCards.map((card, idx) => (
            <Link
              key={idx}
              to={card.href}
              className="card-glow group block bg-background-50 border border-background-200/60 p-6 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500/10 mb-5 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${card.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {lang === 'en' ? t(`admission.guide.card.${idx}.title`) : card.title}
              </h3>
              <p className="text-[12px] text-foreground-400 tracking-[0.1em] mb-3 font-label">
                {card.titleEn}
              </p>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-4">
                {lang === 'en' ? t(`admission.guide.card.${idx}.desc`) : card.description}
              </p>
              <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                <span className="text-[13px] tracking-[0.06em]">{t('admission.guide.arrowLabel')}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
